<div class="main-page-container" style="background-image: url(assets/Images/tgts/tg-bg.png);">
  <div class="header-container">
    <img src="assets/Images/tgts/header.png" alt="" class="header-img">
  </div>

  <div class="logo-container">
    <img src="assets/Images/tgts/logo.png" alt="" class="logo">
  </div>

  <div class="title-container">
    <p class="title">Craft Your Telangana Trip, Your Way!</p>
  </div>

  <div class="form-main-container">
    <form [formGroup]="tripDetailsForm" >
      <div class="no-of-days-container">
        <div class="input-container days-input-container">
          <label for="" class="label">No Of Days</label>
          <app-increment-number-input [max]="99" formControlName="days"></app-increment-number-input>
        </div>

        <div class="input-container">
          <label for="" class="label">Start Date</label>
          <app-date-picker [minDate]="today()"  formControlName="startDate"></app-date-picker>
        </div>
      </div>

      <div class="row py-3 locations-inputs">
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Start Location</label>
            <div>
              <app-locations-autocomplete [placeHolder]="'Enter Location'" (predictionSelected)="handlePrediction($event)" formControlName="startLocation"></app-locations-autocomplete>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">End Location</label>
            <div>
              <app-locations-autocomplete [placeHolder]="'Enter Location'"  formControlName="endLocation"></app-locations-autocomplete>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">No Of Visitors</label>
            <div>
              <app-no-of-guests-input formControlName="noOfGuests"></app-no-of-guests-input>
            </div>
          </div>
        </div>
      </div>

      <div class="button-container d-flex justify-content-center">
        <ion-button class="filled-blue-btn submit-btn" (click)="onSubmit()" [disabled]="tripDetailsForm.invalid">Generate My Trip</ion-button>
      </div>
    </form>
  </div>
</div>